(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g-countdown"]) return;
  try {
    
	class CountdownTimerBar extends HTMLElement {
		constructor() {
			super();
		}
		init() {
			// schema-time is in ISO 8601 UTC format
			this.schemaTime = this.getAttribute('schema-time');
			this.timer = this.querySelector('.timer');
			this.countdown = Date.parse(this.schemaTime);
			this.second = 1000;
			this.minute = this.second * 60;
			this.hour = this.minute * 60;
			this.day = this.hour * 24;
			this.timerInterval = null;
			this.startTimer();
			// Make the timer visible after initializing
			setTimeout(() => (this.timer.style.visibility = 'visible'), 0);
		}
		padWithLeadingZero(number) {
			return number < 10 ? '0' + number : number;
		}
		isDateInPast(date) {
			const now = new Date();
			return date < now;
		}
		startTimer() {
			const timerElem = this.timer;
			const timerFlexContainer = document.querySelector(
				'.timer-flex-container'
			);
			this.timerInterval = setInterval(() => {
				const now = new Date().getTime();
				const distance = this.countdown - now;
				// Check if the countdown has finished
				if (distance <= 0) {
					clearInterval(this.timerInterval); // Stop the timer
					timerFlexContainer.style.display = 'none'; // Hide the timer container
					document.body.classList.remove('countdownislive'); // Remove the class from body
					// Optional: Display a message or take another action
					// For example, you can display an alert or show a hidden element
					// alert("The countdown has ended!");
					return; // Exit the function
				}
				const dayCalc = Math.floor(distance / this.day);
				const hourCalc = Math.floor((distance % this.day) / this.hour);
				const minuteCalc = Math.floor((distance % this.hour) / this.minute);
				const secondCalc = Math.floor((distance % this.minute) / this.second);
				timerElem.querySelector('.js-timer-days').textContent =
					this.padWithLeadingZero(dayCalc);
				timerElem.querySelector('.js-timer-hours').textContent =
					this.padWithLeadingZero(hourCalc);
				timerElem.querySelector('.js-timer-minutes').textContent =
					this.padWithLeadingZero(minuteCalc);
				timerElem.querySelector('.js-timer-seconds').textContent =
					this.padWithLeadingZero(secondCalc);
			}, this.second);
		}
		disconnectedCallback() {
			clearInterval(this.timerInterval);
		}
		connectedCallback() {
			this.init();
			const timerFlexContainer = window.document.querySelector(
				'.timer-flex-container'
			);
			// Check if the countdown has already ended when the component is mounted
			if (this.isDateInPast(this.countdown)) {
				timerFlexContainer.remove();
				this.remove();
				document.body.classList.remove('countdownislive'); // Remove the class from body if the countdown is already in the past
			}
			// Reveal the timer after a short delay
			window.setTimeout(() => {
				timerFlexContainer.classList.remove('hide-element');
			}, 2000);
		}
	}
	customElements.define('countdown-timer-bar', CountdownTimerBar);
	document.addEventListener('DOMContentLoaded', function () {
		if (document.querySelector('.timer-flex-container')) {
			setTimeout(function () {
				document.body.classList.add('countdownislive');
			}, 1000);
		}
	});

  } catch(e) { console.error(e); }
})();
})();
